import ComparisonTemplate from '../vs/ComparisonTemplate'

const competitor = {
  name: 'Simply Safe Dividends',
  slug: 'simplysafedividends',
  tagline: 'Simply Safe Dividends is a premium dividend research platform known for its safety scores. Here\'s how it compares to Safe Dividend Tracker for portfolio tracking.',
  category: 'Dividend research platform',
  seoTitle: 'Safe Dividend Tracker vs Simply Safe Dividends — Full Comparison',
  seoDescription: 'Safe Dividend Tracker vs Simply Safe Dividends: pricing, features, and who each is best for. SDT is free forever — Simply Safe Dividends costs $499/year.',
  price: 'From $499/year',
  priceNote: 'Simply Safe Dividends pricing based on publicly available information and may change. Safe Dividend Tracker free plan has no time limit.',
  features: {
    free:     false,
    divTrack: true,
    drip:     false,
    calendar: true,
    cc:       false,
    csp:      false,
    wheel:    false,
    sync:     true,
    mobile:   false,
    reports:  true,
    webull:   false,
  },
  strengths: [
    'Industry-leading Dividend Safety Scores — the most trusted tool for researching the risk of a dividend cut before it happens.',
    'Deep fundamental research on individual dividend stocks, REITs, and MLPs.',
    'Long track record with a strong reputation among serious dividend income investors.',
    'Excellent dividend growth analysis — useful for building a long-term dividend growth portfolio.',
  ],
  verdict: {
    sdtWins: [
      'Free forever — vs $499/year',
      'Covered call & wheel strategy tracker',
      'DRIP snowball projections',
    ],
    bottomLine: 'Simply Safe Dividends is a research tool first and a tracker second — and it costs $499/year. If you need dividend safety scores and deep stock research, it\'s worth the price. But for tracking your portfolio, projecting DRIP income, and managing options alongside dividends, Safe Dividend Tracker does more for free.',
  },
  bestFor: {
    sdt: 'You want to track your dividend portfolio, project DRIP snowball growth, and log covered calls or CSPs — all without paying $499/year. You want mobile apps and a clean dashboard.',
    competitor: 'You are a serious dividend growth investor who needs deep fundamental research, dividend cut risk analysis, and safety scores before buying or holding a stock.',
  },
  faq: [
    {
      q: 'How much does Simply Safe Dividends cost?',
      a: 'Simply Safe Dividends costs approximately $499/year. Safe Dividend Tracker has a free plan with no time limit, and paid tiers starting at a fraction of that price.',
    },
    {
      q: 'Does Simply Safe Dividends track covered calls?',
      a: 'No. Simply Safe Dividends is a research platform focused on dividend safety and fundamental analysis. It does not track covered calls, cash-secured puts, or options income.',
    },
    {
      q: 'Does Simply Safe Dividends have DRIP projections?',
      a: 'Simply Safe Dividends focuses on dividend safety scoring and research rather than DRIP compounding projections. Safe Dividend Tracker includes a full DRIP snowball calculator that projects your income over 5, 10, 20, or 30 years.',
    },
    {
      q: 'Can I use both Simply Safe Dividends and Safe Dividend Tracker?',
      a: 'Yes — many investors use Simply Safe Dividends for research (to check dividend safety scores before buying) and Safe Dividend Tracker to manage and track their actual portfolio. Safe Dividend Tracker is free to start.',
    },
    {
      q: 'Does Simply Safe Dividends have a mobile app?',
      a: 'Simply Safe Dividends is primarily a web-based platform. Safe Dividend Tracker has native iOS and Android apps on the App Store and Google Play.',
    },
  ],
}

export default function VsSimplySafeDividends() {
  return <ComparisonTemplate competitor={competitor} />
}
